const Checked = () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="13" stroke="green" strokeWidth="2"/>
        <path d="M13.5246 22L23 12.5091L21.4598 11L13.5246 18.9482L9.5067 14.9238L8 16.4329L13.5246 22Z" fill="green"/>
    </svg>
)

export default Checked;